import { IonButtons, IonHeader, IonTitle, IonToolbar } from '@ionic/react';
import { FC, ReactElement, useMemo } from 'react';
import ProfileIcon from '../../assets/icons/ProfileIcon';
import { Modals, Routes } from '../../exports/Enums';
import useModalRouter from '../../common/hooks/useModalRouter';
import useRouter from '../../../../hooks/navigation/useRouter';
import ChevronLeftIcon from '../../assets/icons/ChevronLeftIcon';
import Button from '../../components/buttons/Button';
import { useTranslation } from 'react-i18next';

const AVOIDED_PROFILE_ICON_PAGES: Readonly<Routes[]> = [
  Routes.Cart,
  Routes.Checkout,
  Routes.GiftCardCheckout,
  Routes.GiftCardOrderDetails,
  Routes.OrderDetails,
] as const;

interface Props {
  title: string;
  onBackClick?: () => void;
  hasBackButton?: boolean;
}

const PageHeader: FC<Props> = ({ title, onBackClick, hasBackButton = true }): ReactElement => {
  const { openModal } = useModalRouter();
  const { goBack, getActivePage } = useRouter();
  const { t } = useTranslation(null, { keyPrefix: 'Modules:Mobile:Components:Headers:PageHeader' });
  const hasProfileIcon = useMemo(() => !AVOIDED_PROFILE_ICON_PAGES.includes(getActivePage()), [getActivePage]);

  return (
    <IonHeader>
      <IonToolbar
        style={{
          '--background': 'white',
          '--padding-top': '10px',
          '--padding-bottom': '10px',
          '--padding-start': '16px',
          '--padding-end': '16px',
        }}
      >
        {hasBackButton && (
          <IonButtons slot="start">
            <Button design="link" onClick={() => (onBackClick ? onBackClick() : goBack())}>
              <>
                <ChevronLeftIcon className="stroke-brand-primary h-[14px] w-[10px] mr-xs" />
                <span className="text-brand-primary font-semibold text-base">{t('buttons.back')}</span>
              </>
            </Button>
          </IonButtons>
        )}
        {hasProfileIcon && (
          <IonButtons slot="end" onClick={() => openModal({ id: Modals.Profile })}>
            <ProfileIcon className="stroke-black size-6" />
          </IonButtons>
        )}
        <IonTitle>{title}</IonTitle>
      </IonToolbar>
    </IonHeader>
  );
};

export default PageHeader;
